import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import useAuth from "../../../hooks/useAuth";
import { clearAuthSession } from "../../../shared/auth/lib/authSession";
import {
  getAppsPortalUrl,
  isAppsPortalRedirectEnabled,
  redirectToAppsPortalIfEnabled,
} from "../../../shared/auth/lib/appsPortal";
import { keycloak } from "../../../shared/auth/lib/keycloakClient";

export const useLogoutPage = () => {
  const { setAuth } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Limpiar primero la sesión local: keycloak.logout() navega el
    // navegador, así que nada después de esa llamada tiene garantía de
    // ejecutarse.
    clearAuthSession();
    setAuth({});

    if (keycloak.authenticated) {
      // Hay que pasar por el end-session de Keycloak para cerrar también la
      // sesión SSO; solo cambia a dónde vuelve el navegador después: al portal
      // de apps cuando la integración está activa, o a la app si no lo está.
      const redirectUri = isAppsPortalRedirectEnabled()
        ? getAppsPortalUrl()
        : window.location.origin;

      keycloak.logout({ redirectUri });
      return;
    }

    if (redirectToAppsPortalIfEnabled()) {
      return;
    }

    navigate("/login", { replace: true });
  }, [navigate, setAuth]);
};
